<template>
  <div id="notifications" class="notifications" v-loading.body="loading">
    <span v-if="messages && messages.length > 0">
      <span v-for="message in messages">
        <span :class="getMessageStyle(message)">
          <div class="message">
            <div class="message-header">
              <div style="width:100%">
                {{ formatDate(message.created) }}
                <el-checkbox v-model="message.isRead" @change="read(message)" style="float:right"><span style="color:#fff;font-size:1rem;">Прочитано</span></el-checkbox>
              </div>
            </div>
            <div class="message-body">
              {{ message.text }}
            </div>
          </div>
        </span>
      </span>
    </span>
    <span v-else class="middle-aligned information">
      <div>У вас нет еще ни одного уведомления</div>
    </span>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'

  export default {
    name: 'notifications',
    data() {
      return {
        messages: [],
        loading: true
      }
    },
    methods: {
      read(message) {
        if(message) {
          if(!message.read) {
            let self = this;
            let prefix = config.API_PREFIX;
            this.$gf.getOptions().then(options => {
              this.loading = true;
              options.params = {
              };
              let setter = {
                id : message.uid,
                datetime : new Date()
              };
              self.$http.put(`${prefix}notifications/markasread`, setter, options)
                .then(response => {
                  Event.$emit('notificationCountChange');
                  this.loading = false;
                })
                .catch(data =>  {
                  this.loading = false;
                  self.$gf.checkError(data);
                });
              }).catch(err => {
                this.loading = false;
                this.$gf.catchOptions()
              });
          }
          message.isRead = true;
        }
      },
      getMessageStyle(message) {
        let clazz = 'read';
        if(message && !message.isRead)
          clazz = 'unread';
        return clazz;
      },
      formatDate(d) {
        if(d) {
          d = new Date(d);
          var dateFormat = require('dateformat');
          return dateFormat(d, 'dd.mm.yyyy HH:MM:ss');
        }
        return '';
      },
      fetchData() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///NOTIFICATIONS
          self.$http.get(`${prefix}notifications`, options)
            .then(response => {
              self.messages = response.data;
              this.loading = false;
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      }
    },
    created: function () {
      this.fetchData();
    }
  }

</script>

<style scoped>
  .notifications {
    height: calc(100% - 20px);
    background: #eef1f6;
    border: 1px solid #d1dbe5;
    border-radius: 4px !important;
    overflow-y: scroll;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .information {
    width: 100%;
    height: 100%;
    text-align: center;
  }
</style>
<style>
  .unread .message-header {
    background-color: #375b81 !important;
  }
  .read .message-header {
    /*background-color: #597da3 !important;*/
    background-color: #7b9fc5 !important;
  }
  .message-body {
    text-align: justify;
    text-justify: inter-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/notifications.vue